import { CUSTOMER_TYPES } from "store/types";

const initialState = {
  customers: [],
  totalCount: 0,
  currentPage: 1,
  loading: false,
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_TYPES.SET_LOADING:
      return { ...state, loading: action.payload };

    case CUSTOMER_TYPES.FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.payload.results,
        totalCount: action.payload.count,
        currentPage: action.payload.page,
      };

    default:
      return state;
  }
};

export default customerReducer;
